"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  component: {
    workPermitTips: '(提示：请上传最终审批的作业许可)',
    fileInfo: '附件信息',
    uploadFile: '上传附件',
    fileUpload: '附件上传',
    sqlUpload: 'SQL上传',
    more: '更多',
    no: '序号',
    syncFlag: '船岸同步',
    fileName: '附件名称',
    contentFlag: '摘要',
    uploadTime: '上传时间',
    uploadDept: '上传部门',
    uploader: '上传人',
    option: '操作',
    fileUploadType: '附件上传业务类型',
    vesselSync: '船岸同步',
    file: '附件',
    sqlFile: 'SQL',
    preTip: '按住Ctrl键可多选上传，最多同时上传',
    preTipMaterial: '最多上传',
    // 只能上传***文件
    sufTip: '个文件;且不超过10M',
    // 只能上传***文件，
    editTip: '且不超过3M',
    plsChooseBusinessType: '请选择业务类型',
    plsChooseFile: '请选择文件',
    fileNoHt3MB: '附件大小不能超过 3MB!',
    fileNoHt10MB: '附件大小不能超过 20MB!',
    uploadNumCheck1: '单次最多只能同时选择',
    uploadNumCheck2: '份文件上传。本次您选择了 ',
    uploadNumCheck3: '份文件，请调整后再试'
  },
  workflow: {
    companyName: '公司名称',
    process: '审批意见',
    option: '操作',
    currentApprover: '当前审批人',
    currentDept: '当前审批部门',
    handlingOpinions: '处理意见',
    remark: '个人备注',
    remarkTip: '(该备注为当前待办备注，仅自己可见)',
    addRemark: '添加备注',
    commonOpinions: '常用意见',
    pleInputOpinions: '请输入处理意见',
    pleInputRemark: '无备注信息',
    remindVessel: '提醒船端',
    approvalHistory: '历史审批意见',
    approvalProcess: '审批环节',
    approvalDate: '审批时间',
    approver: '审批人',
    approvalDept: '审批部门',
    certigier: '授权人',
    approvalOption: '审批操作',
    approvalOpinion: '审批意见',
    forSelect: '待选人员',
    selected: '已选人员',
    seqNo: '序号',
    userName: '用户名',
    employeeNo: '工号',
    name: '姓名',
    dept: '部门',
    turnTo: '转办',
    transferRole: '转办角色',
    transferUser: '转办人员',
    transferRemark: '转办备注',
    transferSuccess: '转办成功',
    saveRemarkSuccess: '备注成功'
  },
  compliance: {
    complianceFile: '合规筛查附件',
    complianceScreening: '合规筛查/制裁情况筛查',
    integrityAudit: '诚信情况审核',
    upload: '上传'
  },
  systemPractice: {
    systemDocuments: '体系文件'
  }
};